var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
// @ is an alias to /src
import WorkbenchNav from '@/layout/components/Navs/workbench.vue';
import PlgMenu from '@/layout/components/Navs/PlgMenu.vue';
import SettingNav from '@/layout/components/Navs/setting.vue';
import Header from '@/layout/components/Header/index.vue';
import Error404 from '@/layout/components/Error/404.vue'; // 无页面
import CrmLayout from './Crm/index.vue';
import CustomerService from '@/layout/components/CustomerService.vue'; // 联系客服浮窗
// import IM from '@/common/components/Bussiness/IM/index.vue';
import IMMessageIcon from '@/common/components/Bussiness/IM/IMMessageIcon.vue';
import MicroApplicationRoute from '@/common/components/Qiankun/MicroApplicationRoute.vue';
import { getStorage, getCookie } from '@lhb/cache';
import FloatButton from '@/common/components/Bussiness/FloatButton/index.vue';
import EditUserInfoModal from '../components/Header/EditUserInfoModal.vue';
import CompanyChangeModal from '../components/Header/CompanyChangeModal.vue';
import eventLib from '@/common/utils/document-event';
import IMModal from '@/common/components/Bussiness/IM/IMModal.vue';
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.NODE_ENV = process.env.NODE_ENV;
        _this.micrAppInstance = null;
        _this.fullRoutes = [];
        _this.slideCollapse = false; // 左侧菜单栏是否收起
        _this.useMicro = Boolean(process.env.npm_config_micro);
        return _this;
    }
    Layout.prototype.beforeDestroy = function () {
        if (this.micrAppInstance && typeof this.micrAppInstance.unmount === 'function') {
            this.micrAppInstance.unmount();
        }
    };
    Layout.prototype.onMicroAppChange = function (micrApp) {
        this.micrAppInstance = micrApp;
    };
    Object.defineProperty(Layout.prototype, "routeStatus", {
        /* computed */
        get: function () {
            var _this = this;
            var otherRoutes = ['/lhb-micro-pms/', '/manage/', '/bi/', '/crm/', '/oa/', '/person'];
            var someHasNav = otherRoutes.some(function (e) { return _this.$route.fullPath.indexOf(e) !== -1; });
            return (this.fullRoutes.includes(this.$route.path) ||
                someHasNav || // erp微服务
                this.$route.path === '/'
                ? 200 : 404);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Layout.prototype, "isIMShow", {
        get: function () {
            if (this.$route.path === '/lhb-micro-pms/brandBusiness') {
                return true;
            }
            else {
                return false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Layout.prototype, "isShowNav", {
        get: function () {
            var _this = this;
            // erp微服务, crm都需要
            var otherRoutes = ['/lhb-micro-pms/', '/manage/', '/bi/', '/crm/', '/oa/', '/person'];
            var someHasNav = otherRoutes.some(function (e) { return _this.$route.fullPath.indexOf(e) !== -1; });
            return (someHasNav || !!this.$route.meta.isShowNav) && !this.$route.meta.isNotShowNav;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Layout.prototype, "isCrm", {
        get: function () {
            var _this = this;
            var otherRoutes = ['/manage/', '/bi/', '/crm/', '/oa/', '/person'];
            var someHasNav = otherRoutes.some(function (e) { return _this.$route.fullPath.indexOf(e) !== -1; });
            return someHasNav;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Layout.prototype, "isShowHeader", {
        get: function () {
            return this.$route.meta.isShowHeader || this.$route.meta.isShowHeader === undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Layout.prototype, "user", {
        get: function () {
            return this.$store.getters['getUserInfo'];
        },
        enumerable: false,
        configurable: true
    });
    /* hook */
    Layout.prototype.created = function () {
        this.fullRoutes = this.$router.options.routes.map(function (item) { return item.path; });
        this.init();
    };
    Layout.prototype.init = function () {
        var _this = this;
        var pathName = window.location.pathname;
        if (pathName === '/auth/pms-admin-callback' ||
            pathName === '/auth/login-callback' ||
            pathName === '/company/apply' ||
            pathName === '/agreement/privacy' ||
            pathName === '/agreement/appPrivacy' ||
            pathName === '/agreement/location' ||
            pathName === '/schedule/static' ||
            pathName === '/company/create' ||
            pathName === '/businessOpportunity/detail' ||
            pathName === '/lhb-micro-pms/ppt') {
            return;
        }
        var paths = ['/login', '/login/retrieve-password'];
        if (!(getCookie('newPmsToken') || getStorage('newPmsToken')) && paths.indexOf(pathName) < 0) {
            return window.$_EventLib.dispatch('LOGOUT', '登录已失效, 请重新登录');
        }
        /**
         * 钉钉内打开时通过dingtalk.js api获取企业标识（CORPID）
         * 若钉钉切换了企业，this.$CORPID会与当前用户的corpId不一致
         * 若网页不在登录页时退出到登录页自动登录
         */
        setTimeout(function () {
            var user = _this.$store.state.common.user;
            if (_this.$CORPID && user && user.corpId !== _this.$CORPID && _this.$route.path !== '/login') {
                return window.$_EventLib.dispatch('LOGOUT', null);
            }
        }, 0);
    };
    Layout.prototype.mounted = function () {
        var _this = this;
        eventLib.on('EDIT_USER', function () {
            _this.$refs.editUserInfoModal && _this.$refs.editUserInfoModal.init();
        });
        eventLib.on('CHANGE_COMPANY', function () {
            _this.$refs.companyChangeModal && _this.$refs.companyChangeModal.init();
        });
        eventLib.on('OPEN_IM', function () {
            _this.$refs.IMModalRef.open();
        });
    };
    Layout = __decorate([
        Component({
            components: {
                PlgMenu: PlgMenu,
                WorkbenchNav: WorkbenchNav,
                SettingNav: SettingNav,
                Header: Header,
                Error404: Error404,
                CustomerService: CustomerService,
                MicroApplicationRoute: MicroApplicationRoute,
                CrmLayout: CrmLayout,
                IMMessageIcon: IMMessageIcon,
                FloatButton: FloatButton,
                EditUserInfoModal: EditUserInfoModal,
                CompanyChangeModal: CompanyChangeModal,
                IMModal: IMModal
                // IM
            },
        })
    ], Layout);
    return Layout;
}(Vue));
export default Layout;
